import React from "react";
import { array } from "prop-types";

import NewsWithNoImage from "../../../molecules/NewsWithNoImage";
import LeftImageRightNews from "../../../molecules/LeftImageRightNews";

import "./row2leftcolumn.m.css";

const Row2LeftColumn = ({ stories }) => {
  const row2FirstThreeStories = stories && stories.slice(0, 3);
  const row2SecondSixStories = stories && stories.slice(3, 9);
  return (
    <div styleName="big_box">
      <div className="big_box_row_1" styleName="big_box_row_1">
        {row2FirstThreeStories &&
          row2FirstThreeStories.map(({ story }, index) => <NewsWithNoImage key={index} story={story} />)}
      </div>
      <div styleName="big_box_row_2">
        {row2SecondSixStories &&
          row2SecondSixStories.map(({ story }, index) => <LeftImageRightNews key={index} story={story} />)}
      </div>
    </div>
  );
};

Row2LeftColumn.propTypes = {
  stories: array.isRequired,
};

export default Row2LeftColumn;
